import { FC, useMemo } from 'react';
import { getHtmlTags } from 'src/functions/getHtmlTags';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import Spacing from 'src/styles/layouts/Spacing';
import NGIcon from 'src/styles/theme/components/NGIcon';
import { EIcon } from 'src/styles/theme/components/NGIcon/NGIcon.enum';
import NGText from 'src/styles/theme/components/NGText';
import { EFontStyle, ETextAlign } from 'src/styles/theme/components/NGText/NGText.enum';
import { ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { getEnumFromKey } from 'src/styles/theme/utils/functions';
import { FlexEx } from './Warning.styles';
import { IWarning } from './Warning.type';

const Warning: FC<IWarning> = ({ title, message }) => {
	const icon = useMemo(() => {
		if (title) {
			return getEnumFromKey(title, EIcon);
		}

		return EIcon.none;
	}, [title]);

	if (!message) {
		return <></>;
	}

	return (
		<FlexEx
			direction={EFlex.row}
			vertical={EFlex.center}
			horizontal={EFlex.start}
			marginTop={ESize['4xs']}
			marginBottom={ESize['4xs']}
			marginLeft={ESize['2xs']}
			paddingRight={ESize['2xs']}
		>
			{icon !== EIcon.none && icon !== EIcon.unset ? (
				<NGIcon type={icon} size={ESize.s} color={ETextColor.gold} marginX={ESize['4xs']} width={'18px'} />
			) : (
				<Spacing size={ESize['4xs']} />
			)}
			<NGText textAlign={ETextAlign.left} textColor={ETextColor.gold} fontStyle={EFontStyle.italic} size={ESize.s}>
				{typeof message === 'string' ? getHtmlTags(message) : message}
			</NGText>
		</FlexEx>
	);
};
export { Warning };
